import { isPlainObject } from 'lodash-es';
import type { JsonObject } from 'type-fest';
import xss from 'xss';

const sanitizeObjectEntries = <T>(data: T): T => {
  const sanitizeValue = <G>(value: G): G | unknown[] | string => {
    if (isPlainObject(value)) {
      return sanitizeObjectEntries(value);
    }
    if (typeof value === 'string') {
      return xss(value);
    }
    if (Array.isArray(value)) {
      return value.map((v) => sanitizeValue(v));
    }

    return value;
  };

  if (isPlainObject(data)) {
    return Object.fromEntries(
      Object.entries(data as JsonObject).map((entries) => entries.map((entry) => sanitizeValue(entry)))
    );
  }

  return data;
};

export default sanitizeObjectEntries;
